import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/components/Dashboard'
import Report from '@/components/Report'
import BadGateway from '@/components/BadGateway'
import Students from '@/components/Students'
import StudentsReport from '@/components/StudentsReport'
import Login from '@/components/Login'
import AddArtVideo from '@/components/AddArtVideo'
import ArtVideos from '@/components/ArtVideos'
import Quizs from '@/components/Quizs'


Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'Login',
            props: { page: 5 },
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            props: { page: 1 },
            alias: '/',
            meta: { requiresAuthAdmin: true },

        },
        {
            path: '/report',
            name: 'Report',
            component: Report,
            props: { page: 2 },
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/students',
            name: 'Students',
            props: { page: 2 },
            component: Students,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/students-report',
            name: 'StudentsReport',
            props: { page: 2 },
            component: StudentsReport,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/404',
            name: 'BadGateway',
            props: { page: 5 },
            component: BadGateway,
        },
        {
            path: '*',
            props: { page: 5 },
            redirect: '/404'
        },
        {
            path: '/home',
            props: { page: 5 },
            redirect: '/dashboard',
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/artvideos',
            name: 'ArtVideos',
            props: { page: 3 },
            component: ArtVideos,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/artvideos/:videoId/quizs',
            name: 'Quizs',
            props: { page: 8 },
            component: Quizs,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-art-videos',
            name: 'AddArtVideo',
            props: { page: 4 },
            component: AddArtVideo,
            meta: { requiresAuthAdmin: true },
        },

    ],

})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuthAdmin)) {
        if (!localStorage.getItem('fastAdminToken')) {
            next({
                name: "Login"
            })
        } else {
            next();
        }
    } else {
        next();
    }

    if (to.matched.some(record => record.meta.requiresAuthTeacher)) {
        if (!localStorage.getItem('fastTeacherToken')) {
            next({
                name: "LoginTeacher"
            })
        } else {
            next();
        }
    } else {
        next();
    }


})

export default router